import cn from 'clsx'
import { FC, ReactNode } from 'react'

import { Typography } from '@/components/ui'

type HistoryCellProps = {
	className?: string
	children: ReactNode
}

const headerCellBaseClass = 'w-[12.5%] min-w-[100px] pl-3'

const HeaderCell: FC<HistoryCellProps> = ({ className, children }) => {
	return (
		<Typography variant='text' className={cn(headerCellBaseClass, className)}>
			{children}
		</Typography>
	)
}

const HistoryTableHeader = () => {
	return (
		<>
			<HeaderCell className='!w-[15%]'>ID</HeaderCell>
			<HeaderCell className='!w-[7.5%]'>Listener</HeaderCell>
			<HeaderCell>User name</HeaderCell>
			<HeaderCell>Started_at</HeaderCell>
			<HeaderCell>Finished_at</HeaderCell>
			<HeaderCell>Runtime</HeaderCell>
			<HeaderCell className='!w-[7.5%]'>Status</HeaderCell>
			<HeaderCell className='!w-[20%]'>Download_url</HeaderCell>
		</>
	)
}

export default HistoryTableHeader
